<template>
    <div>
        <FormSection
            title="Patient Goals"
            :popoverContent="popoverContent"
            :full-height="false"
            :application-id="application"
            type="his-section"
        >
            <template #content>
                <div class="col-12 offset-lg-1 pt-2 col-lg-10">
                    <label for="patients-personal-goals" class="mb-2"> <b>Patient's Personal Goals</b></label>
                    <CommentInput
                        id="patients-personal-goals"
                        :result="patient.patientGoals.personalGoals"
                        v-on:resultUpdatedAppended="resultPersonalGoalsAppended"
                        v-on:resultUpdated="resultPersonalGoals"
                        placeholder="Enter Patient's Personal Goals"
                        :application="application"
                    />
                </div>
                <div class="col-12 offset-lg-1 pt-2 col-lg-10">
                    <label for="patients-care-goals" class="mb-2"> <b>Patient's Care Goals</b></label>
                    <CommentInput
                        id="patients-care-goals"
                        :result="patient.patientGoals.careGoals"
                        v-on:resultUpdatedAppended="resultCareGoalsAppended"
                        v-on:resultUpdated="resultCareGoals"
                        placeholder="Enter Patient's Care Goals"
                        :application="application"
                    />
                </div>
                <div class="col-12 offset-lg-1 pt-2 col-lg-10">
                    <label for="barrier-care-goals" class="mb-2"> <b>Barriers to Care/Goals</b></label>
                    <CommentInput
                        id="barrier-care-goals"
                        :result="patient.patientGoals.barriersToPersonalOrCareGoals"
                        v-on:resultUpdatedAppended="resultBarriersGoalsAppended"
                        v-on:resultUpdated="resultBarriersGoals"
                        placeholder="Enter Barriers to Care/Goals"
                        :application="application"
                    />
                </div>
                <div class="col-12 offset-lg-1 pt-2 col-lg-10">
                    <label for="crisis-care-plan" class="mb-2"> <b>Crisis Care Plan</b></label>
                    <CommentInput
                        id="crisis-care-plan"
                        :result="patient.patientGoals.crisisCarePlan"
                        v-on:resultUpdatedAppended="resultCrisisCareAppended"
                        v-on:resultUpdated="resultCrisisCare"
                        placeholder="Enter Crisis Care Plan"
                        :application="application"
                    />
                </div>
            </template>
        </FormSection>
    </div>
</template>

<script lang="ts" src="./PatientGoals.ts"></script>
